<template>
  <b-modal
    ref="exportModal"
    title="Xuất Excel nhóm nhà cung cấp"
    size="md"
    hide-footer
    centered
  >
    <div class="p-3">
      <h5 class="mb-4">Tùy chọn xuất Excel</h5>
      <b-form @submit.prevent="handleExport">
        <b-form-group label="Tên file">
          <b-form-input
            v-model="options.fileName"
            placeholder="Nhập tên file"
            required
          />
        </b-form-group>

        <b-form-group label="Phạm vi xuất">
          <b-form-radio-group
            v-model="options.exportScope"
            :options="exportScopeOptions"
            stacked
          />
        </b-form-group>

        <b-form-group label="Cột cần xuất">
          <b-form-checkbox-group
            v-model="options.selectedFields"
            :options="fieldOptions"
            stacked
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="hideModal"
            :disabled="isExporting"
          >
            Hủy
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="isExporting || options.selectedFields.length === 0"
          >
            <b-spinner
              small
              v-if="isExporting"
              class="mr-1"
            ></b-spinner>
            {{ isExporting ? 'Đang xuất...' : 'Xuất Excel' }}
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { createFile, getFileName } from '@/utils/file-download';
import { SupplierGroupService } from '../service/supplier-group.service';

export default {
  name: 'SupplierGroupExportModal',
  props: {
    searchParams: {
      type: Object,
      default: () => ({}),
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isExporting: false,
      options: {
        fileName: 'danh-sach-nhom-nha-cung-cap',
        exportScope: 'all',
        selectedFields: [
          'name',
          'code',
          'description',
          'providerCount',
          'createdAt',
        ],
      },
      exportScopeOptions: [
        { text: 'Tất cả dữ liệu', value: 'all' },
        { text: 'Dữ liệu hiện tại (theo bộ lọc)', value: 'filtered' },
      ],
      fieldOptions: [
        { text: 'Tên nhóm', value: 'name' },
        { text: 'Mã nhóm', value: 'code' },
        { text: 'Ghi chú', value: 'description' },
        { text: 'Số lượng nhà cung cấp', value: 'providerCount' },
        { text: 'Ngày tạo', value: 'createdAt' },
        { text: 'Ngày cập nhật', value: 'updatedAt' },
      ],
    };
  },
  methods: {
    showModal() {
      this.$refs.exportModal.show();
    },

    hideModal() {
      this.$refs.exportModal.hide();
    },

    async handleExport() {
      if (this.options.selectedFields.length === 0) {
        makeToastFaile('Vui lòng chọn ít nhất một cột để xuất');
        return;
      }

      this.isExporting = true;

      try {
        let params = {
          fields: this.options.selectedFields,
        };

        // If exporting filtered data, include search parameters
        if (this.options.exportScope === 'filtered') {
          params = {
            ...params,
            ...this.searchParams,
          };
        }

        const response = await SupplierGroupService.exportToExcel(params);

        // Handle file download
        const fileName =
          getFileName(response) || `${this.options.fileName}.xlsx`;
        createFile(response.data, fileName);

        makeToastSuccess('Xuất Excel thành công');
        this.hideModal();
        this.$emit('export-success');
      } catch (error) {
        console.error('Export error:', error);
        const errorMessage =
          error.response?.data?.message || 'Có lỗi xảy ra khi xuất Excel';
        makeToastFaile(errorMessage);
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
  color: #6c757d;
}
</style>
